import { Component, Input } from '@angular/core';
import { CoreUtilityService } from '../../utilities/services/utility.service';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html'
})

export class DatepickerComponent {
  @Input() fieldControl;
  @Input() form;
  @Input() type;

  constructor(private coreUtilityService: CoreUtilityService) { }

  /**
   * getter function to check mandatory fields
   */
  get isMandatory(): boolean {
    try {
      return this.fieldControl.validations.mandatory.value;
    } catch (error) { return false; }
  }

  /**
   * This method will monitor the date change event
   * @param event - change event
   */
  public onDateChange(event): void {
    this.form.date = event;
    // this.form.get(this.fieldControl.logicalName).setValue(this.coreUtilityService.formatDate(this.form.date.value))
    // this.form.value[this.fieldControl.logicalName] = this.coreUtilityService.formatDate(this.form.date.value);
    const tempObj = {};
    tempObj[this.fieldControl.logicalName] = this.coreUtilityService.formatDate(this.form.date.value);
    this.form.patchValue(tempObj);
  }

}
